const solutionList = [
    {
        imgPo: "imgLeft",
        type: "行为智能识别",
        name: "",
        title: "",
        label:'behavioral',
        img: "/static/img/product/a1.jpg",
        point: [],
        desc:'',
        fc: [
          
        ],
        btn: {
            show: true,
            text: "查看详情",
        },
        param: [
        ],
    },
    {
        imgPo: "imgLeft",
        type: "生产流程智能监测与分析",
        label:'flow',
        name: "",
        title: "生产流程智能监测与分析",
        img: "/static/img/product/flow.png",
        point: [],
        desc:'',
        fc: [
          
        ],
        btn: {
            show: true,
            text: "查看详情",
        },
        param: [
        ],
    },
];

export default solutionList;
